<div class="w-full">
  @if (noConfirmations) {
    <div class="text-white text-center mt-4 font-semibold bg-toyotaRed p-1 mb-2">
      <span>Sie haben keine Einwilligung abgegeben.</span>
    </div>
  }

  @if (noDigitalSignatures) {
    <div class="text-white text-center mt-4 font-semibold bg-toyotaRed p-1 mb-2">
      <span>Sie haben keine digitale Unterschrift abgegeben.</span>
    </div>
  }

  <img [src]="dshImg">
</div>
